(async () => {
  if (window.dashExport) {
    if (window.isDashboardExport) {
      await import(
        /* webpackChunkName: "dashboard-detail-page" */ './modules/legacy/dashboards/pages/DashboardDetailPage.vue'
      );
    } else {
      await import(
        /* webpackChunkName: "report-studio-detail-page" */ './modules/legacy/reportstudio/pages/ReportStudioDetailPage.vue'
      );
    }

    if (window.useAdobePptConverter) {
      await import(
        /* webpackChunkName: "adobe-export-fonts" */ 'coreModules/export/fonts/adobe.export.fonts.css'
      );
    }

    window.exportDependeciesLoaded = true;
  }
})();
